import React, { Component } from "react";
import Select from "react-select";

import {
  main_url,
  getUserId,
  getMainRole,
  getWorkFlowStatus,
  getCookieData,
  getPermissionStatus,
  startSaving,
} from "../../../utils/CommonFunction";
import { ToastContainer, toast } from "react-toastify";

const EmployeeProfile = (props) => {
  const {
    userImage,
    handleClick,
    hiddenFileInput,
    districtCodeList,
    fullNRC,
    nrcList,
    nrcCategoryList,
    handleProfileSave,
    nrc_number,
    handleChange,
    handleSelectedDistrictCode,
    handleSelectedNRCId,
    handleSelectedNRCCategory,
    NrcFilterData,
    selected_DistrictCode,
    selected_NRC_Id,
    selected_NRC_Category,
    employeeCodePrefixList,
    handleEmployeeCodePrefixChange,
    employeeCodePrefix,
    employeeId,
    region,
    address,
    joinDate,
    nationality,
    personalPhone,
    officePhone,
    dateOfBirth,
    actualDateOfBirth,
    handleInputChange,
    onGenderChange,
    employeeNameEng,
    isEmployeeNameValid,
    employeeNameMyan,
    gender,
    emailAddress,
    handleBloodGroupChange,
    bloodGroupsList,
    bloodGroup,
    handleEducationChange,
    educationList,
    education,
  } = props;
  const { onCancelClick, viewForm, editForm } = props;

  const imgUrl = userImage
    ? userImage.includes("103.29.91.26")
      ? userImage
      : main_url + "confirmation/getProfile/" + userImage
    : "";

  // const nrcErr = () => {
  //     if(nrc_number.length < 6){
  //         toast.error("NRC number should be 6 digit!");
  //     }
  // }

  let fullNRCNO = fullNRC
    ? fullNRC
    : // fullNRC.split(" ")[0] + '/' + fullNRC.split(" ")[1] + '(N)' + fullNRC.split(" ")[2] :
      `${selected_NRC_Id ? selected_NRC_Id.label : ""}${
        selected_DistrictCode ? "/" + selected_DistrictCode.label : ""
      }${
        nrc_number
          ? `(${
              selected_NRC_Category
                ? selected_NRC_Category.nrc_category_code
                : " "
            })` + nrc_number
          : ""
      }`;

  return (
    <form onSubmit={handleProfileSave}>
      <div
        className="white-bg "
        style={{
          paddingTop: 20,
          border: "1px solid lightgrey",
          display: "grid",
          borderTop: "none",
          marginTop: -10,
          paddingBottom: 20,
          boxShadow: "5px 5px 5px lightgrey",
        }}
      >
        <div className="" style={{ display: "flex" }}>
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {" "}
              Profile Photo
            </div>
            <div
              className="col-lg-7 col-md-6 w-100"
              style={{ display: "flex" }}
            >
              <div
                style={{
                  border: "1px solid grey",
                  width: 140,
                  height: 120,
                  borderStyle: "dashed",
                }}
              >
                <img
                  src={imgUrl}
                  alt=""
                  style={{ width: 140, height: 120, objectFit: "contain" }}
                />
              </div>
              {viewForm ? null : (
                <div
                  className=""
                  style={{
                    display: "flex",
                    alignItems: "end",
                    paddingLeft: 10,
                  }}
                >
                  <button
                    onClick={(e) => handleClick(e)}
                    style={{
                      borderRadius: 5,
                      padding: 10,
                      background: "#337ab7",
                      color: "white",
                      border: "none",
                      width: 90,
                    }}
                  >
                    Browse
                  </button>
                  <input
                    type="file"
                    id="user-image"
                    ref={hiddenFileInput}
                    accept="image/*"
                    onChange={(e) => handleChange(e)}
                    style={{ display: "none" }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            paddingTop: 15,
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div className="col-lg-6 col-md-12 col-sm-12" style={{}}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingTop: 15,
              }}
            >
              <div>Employee ID</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <div className="w-100" style={{ display: "flex" }}>
                  {!editForm && !viewForm && (
                    <div
                      className="col-lg-2 col-md-2 col-sm-2"
                      style={{ width: "30%", paddingLeft: 0, paddingRight: 5 }}
                    >
                      <Select
                        options={employeeCodePrefixList}
                        value={employeeCodePrefix}
                        onChange={
                          viewForm ? null : handleEmployeeCodePrefixChange
                        }
                        className="react-select-container checkValidate"
                        tabIndex={10}
                        classNamePrefix="react-select"
                      />
                    </div>
                  )}
                  <div
                    className={
                      editForm || viewForm
                        ? "col-lg-12 col-md-12 col-sm-12"
                        : "col-lg-9 col-md-9 col-sm-9"
                    }
                    style={{ paddingRight: 0, paddingLeft: 0 }}
                  >
                    <input
                      type="text"
                      placeholder=""
                      required={viewForm ? false : true}
                      name="employeeId"
                      tabIndex={1}
                      value={employeeId}
                      style={{ width: "100%", height: 40, paddingLeft: 7 }}
                      autoComplete="off"
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingTop: 15,
              }}
            >
              <div>Employee Name (Eng)</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="text"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="employeeNameEng"
                  tabIndex={2}
                  value={employeeNameEng.toUpperCase()}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    height: 40,
                    color:
                      isEmployeeNameValid === null
                        ? "grey"
                        : isEmployeeNameValid
                        ? "#0080ff"
                        : "red",
                  }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ alignItems: "center", paddingTop: 15 }}>NRC</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <div
                  className="w-100"
                  style={{ display: "flex", paddingBottom: 15 }}
                >
                  <div
                    className="col-lg-2 col-md-2 col-sm-2"
                    style={{ width: "30%", paddingLeft: 0, paddingRight: 5 }}
                  >
                    <Select
                      options={nrcCategoryList}
                      value={selected_NRC_Category}
                      onChange={viewForm ? null : handleSelectedNRCCategory}
                      placeholder=""
                      className="react-select-container checkValidate"
                      tabIndex={10}
                      classNamePrefix="react-select"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-2 col-sm-2"
                    style={{ width: "30%", paddingLeft: 0, paddingRight: 5 }}
                  >
                    <Select
                      options={nrcList}
                      value={selected_NRC_Id}
                      onChange={viewForm ? null : handleSelectedNRCId}
                      placeholder=""
                      className="react-select-container checkValidate"
                      tabIndex={10}
                      classNamePrefix="react-select"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-2 col-sm-2"
                    style={{ width: "50%", paddingLeft: 0, paddingRight: 5 }}
                  >
                    <Select
                      options={NrcFilterData}
                      value={selected_DistrictCode}
                      onChange={viewForm ? null : handleSelectedDistrictCode}
                      className="react-select-container checkValidate"
                      tabIndex={11}
                      classNamePrefix="react-select"
                    />
                  </div>
                  <div
                    className="col-lg-5 col-md-5 col-sm-5"
                    style={{ paddingRight: 0, paddingLeft: 0 }}
                  >
                    <input
                      type="number"
                      placeholder=""
                      required={viewForm ? false : true}
                      name="nrc_number"
                      tabIndex={12}
                      value={nrc_number}
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      onChange={handleInputChange}
                      style={{ width: "100%", height: 40 }}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <input
                  type="text"
                  placeholder=""
                  name=""
                  tabIndex={13}
                  required={viewForm ? false : true}
                  value={fullNRCNO}
                  onChange={() => null}
                  style={{ minWidth: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Employee Name (Myan)</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="text"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="employeeNameMyan"
                  tabIndex={3}
                  value={employeeNameMyan}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>

          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>NRC Date Of Birth</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="date"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="dateOfBirth"
                  tabIndex={14}
                  value={dateOfBirth}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            paddingTop: 10,
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>Gender</div>
            <div
              className="col-lg-7 col-md-6"
              style={{ display: "flex", justifyContent: "space-around" }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  value="male"
                  name="gender"
                  tabIndex={4}
                  required={viewForm ? false : true}
                  checked={gender.toLowerCase() === "male"}
                  onChange={onGenderChange}
                />
                <div style={{ paddingLeft: 10 }}>Male</div>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  value="female"
                  name="gender"
                  tabIndex={5}
                  required={viewForm ? false : true}
                  checked={gender.toLowerCase() === "female"}
                  onChange={onGenderChange}
                />
                <div style={{ paddingLeft: 10 }}>Female</div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 8 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Actual Date Of Birth</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="date"
                  placeholder=""
                  required={false}
                  name="actualDateOfBirth"
                  tabIndex={15}
                  value={actualDateOfBirth}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Personal Phone</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="number"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="personalPhone"
                  tabIndex={6}
                  onKeyDown={(e) =>
                    ["e", "E", "+", "-", "."].includes(e.key) &&
                    e.preventDefault()
                  }
                  value={personalPhone}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                  readOnly
                  onFocus={(e) => e.target.removeAttribute("readonly")}
                />
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Blood Group</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <Select
                  options={bloodGroupsList}
                  value={bloodGroup}
                  onChange={handleBloodGroupChange}
                  tabIndex={16}
                  className="react-select-container checkValidate"
                  classNamePrefix="react-select"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Office Phone</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="number"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="officePhone"
                  tabIndex={7}
                  onKeyDown={(e) =>
                    ["e", "E", "+", "-", "."].includes(e.key) &&
                    e.preventDefault()
                  }
                  value={officePhone}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                  readOnly
                  onFocus={(e) => e.target.removeAttribute("readonly")}
                />
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Education</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <Select
                  options={educationList}
                  value={education}
                  onChange={handleEducationChange}
                  tabIndex={17}
                  className="react-select-container checkValidate"
                  classNamePrefix="react-select"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Join Date</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="date"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="joinDate"
                  tabIndex={8}
                  value={joinDate}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Nationality</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="text"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="nationality"
                  tabIndex={18}
                  value={nationality}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Email Address</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="email"
                  placeholder=""
                  required={false}
                  name="emailAddress"
                  tabIndex={9}
                  value={emailAddress}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Religion</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="text"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="region"
                  tabIndex={19}
                  value={region}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            className="col-lg-6 col-md-12 col-sm-12"
            style={{ paddingTop: 15 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Address</div>
              <div className="col-lg-7 col-md-6 col-sm-6">
                <input
                  type="text"
                  placeholder=""
                  required={viewForm ? false : true}
                  name="address"
                  tabIndex={20}
                  value={address}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: 40 }}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          type="button"
          className=""
          onClick={onCancelClick}
          style={{
            borderRadius: 5,
            padding: 10,
            margin: 10,
            background: "red",
            color: "white",
            border: "none",
            width: 90,
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          style={{
            borderRadius: 5,
            padding: 10,
            margin: 10,
            background: "#337ab7",
            color: "white",
            border: "none",
            width: 90,
          }}
          // onClick={nrcErr}
        >
          Next
        </button>
      </div>
    </form>
  );
};

export default EmployeeProfile;
